import React from 'react';
import { useShareWizardContext } from '@/contexts/ShareWizardContext';
import AddressingModeSegment from './AddressingModeSegment';
import { ShareWizardLogic } from './logic';
import styles from './ShareComposer.module.css';

/**
 * The composer's Options tab: how this share goes out, settled before its
 * messages reach the outbox.
 *
 * The "Share as" choice lives here, so the addressing mode is known while the
 * sender is still writing — which is what decides, for instance, whether an
 * optional that names its recipient is on offer in the Form tab. An intent
 * with a single recipient still composes as a direct text whatever is chosen
 * here, because a group text to one person is one.
 */
const ComposerOptionsTab: React.FC = () => {
  const {
    singletonMode,
    setSingletonMode,
    recipientCountsByIntent,
    inProgressLegId,
  } = useShareWizardContext();

  return (
    <div data-testid="garden-composer-options">
      {ShareWizardLogic.canGroupText(recipientCountsByIntent) ? (
        <AddressingModeSegment
          mode={singletonMode ? 'dm' : 'group-text'}
          onChange={mode => setSingletonMode(mode === 'dm')}
          recipientCountsByIntent={recipientCountsByIntent}
          disabled={inProgressLegId != null}
        />
      ) : (
        <p className={styles.empty} data-testid="garden-composer-no-options">
          Each message here goes to one person, so there is nothing to choose
          yet.
        </p>
      )}
    </div>
  );
};

export default ComposerOptionsTab;
